import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sniper-enterprise',
  templateUrl: './sniper-enterprise.component.html',
  styleUrls: ['./sniper-enterprise.component.css']
})
export class SniperEnterpriseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
